var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgModalLogout(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mingcute:user-warning-fill"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 935"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M26.7342 16.3164C25.3093 16.3164 24.1562 17.4695 24.1562 18.8944V81.1099C24.1562 82.5348 25.3093 83.6879 26.7342 83.6879H73.1381V16.3164H26.7342Z",
    fill: "url(#paint0_linear_1106_8117)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M37.3413 43.0236C36.4118 42.0166 34.9057 42.0166 33.9761 43.0236C33.0466 44.0306 33.0466 45.6621 33.9761 46.6691L34.6734 47.4244H21.3798C20.0644 47.4244 19 48.5775 19 50.0024C19 51.4273 20.0644 52.5804 21.3798 52.5804H34.6732L33.9759 53.3357C33.0464 54.3427 33.0464 55.9742 33.9759 56.9812C34.9055 57.9881 36.4114 57.9881 37.3411 56.9812L42.1007 51.8252C43.0303 50.8182 43.0303 49.1867 42.1007 48.1798L37.3413 43.0236ZM79.2481 16.45L50.6904 6.13807C49.9584 5.8636 49.1681 6.00711 48.5453 6.49057C47.9248 6.97643 47.5575 7.75447 47.5575 8.58269V91.4221C47.5575 92.2503 47.9246 93.0284 48.5453 93.5142C49.1902 94.0152 49.9977 94.1213 50.6904 93.8667L79.2481 83.5548C80.2195 83.2048 80.8749 82.2204 80.8749 81.1101V18.8947C80.8749 17.7844 80.2195 16.8 79.2481 16.45Z",
    fill: "url(#paint1_linear_1106_8117)"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1106_8117",
    x1: 48.6472,
    y1: 83.6879,
    x2: 48.6472,
    y2: 16.3164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADDCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5028,
    stopColor: "#EAF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1106_8117",
    x1: 49.9374,
    y1: 94,
    x2: 49.9374,
    y2: 6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#177BF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DAD9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalLogout);
export default __webpack_public_path__ + "static/media/modal_logout.791c291dbe408b1bb74772e5eb070a75.svg";
export { ForwardRef as ReactComponent };